import { render, staticRenderFns } from "./SysPropertiesManager.vue?vue&type=template&id=50e16cee&scoped=true&"
import script from "./SysPropertiesManager.vue?vue&type=script&lang=js&"
export * from "./SysPropertiesManager.vue?vue&type=script&lang=js&"
import style0 from "./SysPropertiesManager.vue?vue&type=style&index=0&id=50e16cee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e16cee",
  null
  
)

export default component.exports